/* eslint-disable @typescript-eslint/no-explicit-any */
import "react-toastify/dist/ReactToastify.css";
import { buildUrl } from "../../utils/bindUrl";
import {
  ICustomer,
  IResponseListCustomers,
  IResponseShowCustomer,
} from "../../interfaces/customers";
import qs from "qs";
import { api } from "../api/httpClient";
import { IListParams } from "@/interfaces/serviceInterface";

const BASE = "/customers";

// serializer padrão (arrays em brackets, ignora null/undefined)
const serialize = (p: any) =>
  qs.stringify(p, { arrayFormat: "brackets", skipNulls: true, encode: true });

export async function listCustomers({
  filter,
  includes,
  page,
  limit,
  select,
  sort,
}: IListParams) {
  const { data } = await api.get<IResponseListCustomers>(BASE, {
    params: { filter, includes, page, limit, select, sort },
    paramsSerializer: (params) => serialize(params),
  });
  return data;
}

export async function showCustomer({
  id,
  includes,
}: {
  id: string | number;
  includes?: string[];
}) {
  const url = buildUrl(`${BASE}/{id}`, { id });
  const { data } = await api.get<IResponseShowCustomer>(url, {
    params: { includes },
    paramsSerializer: (params) => serialize(params),
  });
  return data;
}

export async function createCustomer({ customer }: { customer: ICustomer }) {
  const { data } = await api.post<IResponseShowCustomer>(BASE, { customer });
  return data;
}

export async function updateCustomer({
  id,
  customer,
}: {
  id: string | number;
  customer: Partial<ICustomer>;
}) {
  const url = buildUrl(`${BASE}/{id}`, { id });
  const { data } = await api.put<IResponseShowCustomer>(url, { customer });
  return data;
}

export async function deleteCustomer({ id }: { id: string | number }) {
  const url = buildUrl(`${BASE}/{id}`, { id });
  // validateStatus => true evita cair no interceptor de erro (toast automático)
  const resp = await api.delete(url, { validateStatus: () => true });
  return { status: resp.status, data: resp.data };
}
